module.exports = __webpack_public_path__ + "img/BG.81397ec2.png";